import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FastActionBannerPageModule } from '@com-delta-idp/mnx-fast-action-banner-ui';
import { SmartModule as PartnersModule } from '@com-delta-idp/mnx-skymiles-partners';
import { RelatedLinksModule } from '@com-delta-idp/mnx-skymiles-shared';
import { OffersModule } from '../../features';
import { EarnsComponent } from './earns.component';
import { SkeletonLoaderDirective } from '@com-delta-omnichannel/aura';

@NgModule({
  declarations: [EarnsComponent],
  imports: [
    CommonModule,
    FastActionBannerPageModule,
    OffersModule,
    RelatedLinksModule,
    SkeletonLoaderDirective,
    PartnersModule
  ],
  exports: [EarnsComponent]
})
export class EarnsModule {}
